import React, { useState } from 'react';
import { PageHeader } from '../../components/layout/PageHeader';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Stepper, Step } from '../../components/ui/Stepper';
import { MessageBar } from '../../components/ui/MessageBar';
import { SaveIcon, ArrowRightIcon, ArrowLeftIcon, CheckCircleIcon } from 'lucide-react';
export const OnboardingWorkspace: React.FC = () => {
  const [currentStepId, setCurrentStepId] = useState('company');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const steps: Step[] = [{
    id: 'company',
    label: 'Company Details',
    status: currentStepId === 'company' ? 'current' : 'complete'
  }, {
    id: 'tax',
    label: 'Tax & Reg',
    status: currentStepId === 'tax' ? 'current' : ['company'].includes(currentStepId) ? 'upcoming' : 'complete'
  }, {
    id: 'bank',
    label: 'Bank Details',
    status: currentStepId === 'bank' ? 'current' : ['company', 'tax'].includes(currentStepId) ? 'upcoming' : 'complete'
  }, {
    id: 'compliance',
    label: 'Compliance',
    status: currentStepId === 'compliance' ? 'current' : ['company', 'tax', 'bank'].includes(currentStepId) ? 'upcoming' : 'complete'
  }, {
    id: 'review',
    label: 'Review & Submit',
    status: currentStepId === 'review' ? 'current' : 'upcoming'
  }];
  const handleNext = () => {
    const currentIndex = steps.findIndex(s => s.id === currentStepId);
    if (currentIndex < steps.length - 1) {
      setCurrentStepId(steps[currentIndex + 1].id);
    } else {
      setIsSubmitted(true);
    }
  };
  const handleBack = () => {
    const currentIndex = steps.findIndex(s => s.id === currentStepId);
    if (currentIndex > 0) {
      setCurrentStepId(steps[currentIndex - 1].id);
    }
  };
  if (isSubmitted) {
    return <div className="max-w-3xl mx-auto mt-12 text-center space-y-6" data-id="element-1365">
        <div className="w-20 h-20 bg-status-success-bg rounded-full flex items-center justify-center mx-auto" data-id="element-1366">
          <CheckCircleIcon className="w-10 h-10 text-status-success" data-id="element-1367" />
        </div>
        <h1 className="text-3xl font-bold text-text-primary" data-id="element-1368">
          Onboarding Submitted!
        </h1>
        <p className="text-text-secondary text-lg" data-id="element-1369">
          Thank you for completing your profile. The FairPrice Group team will
          review your submission and notify you within 3-5 business days.
        </p>
        <Button variant="primary" onClick={() => window.location.hash = '#/supplier/dashboard'} data-id="element-1370">
          Return to Dashboard
        </Button>
      </div>;
  }
  return <div className="max-w-5xl mx-auto space-y-6 pb-12" data-id="element-1371">
      <PageHeader title="Supplier Onboarding" description="Complete your registration to become an active supplier for FairPrice Group." breadcrumbs={[{
      label: 'Home',
      href: '/supplier/dashboard'
    }, {
      label: 'Onboarding'
    }]} primaryAction={<Button variant="secondary" leftIcon={<SaveIcon className="w-4 h-4" data-id="element-1374" />} data-id="element-1373">
            Save Draft
          </Button>} data-id="element-1372" />

      <MessageBar type="info" title="Welcome to FairPrice Group" data-id="element-1375">
        Please ensure all information provided is accurate and matches your
        official company documents. This will prevent delays in your
        qualification process.
      </MessageBar>

      <Card className="p-8" data-id="element-1376">
        <Stepper steps={steps} onStepClick={setCurrentStepId} data-id="element-1377" />
      </Card>

      <Card className="p-8" data-id="element-1378">
        {currentStepId === 'company' && <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-1379">
            <h2 className="text-xl font-bold text-text-primary border-b border-border-light pb-4" data-id="element-1380">
              Company Details
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1381">
              <div className="space-y-1" data-id="element-1382">
                <label className="text-sm font-medium text-text-primary" data-id="element-1383">
                  Legal Company Name *
                </label>
                <input type="text" className="w-full p-2 border border-border-default rounded-fluent focus:ring-2 focus:ring-fpg-navy outline-none" defaultValue="Oceanic Harvest Private Limited" data-id="element-1384" />
              </div>
              <div className="space-y-1" data-id="element-1385">
                <label className="text-sm font-medium text-text-primary" data-id="element-1386">
                  Trading Name
                </label>
                <input type="text" className="w-full p-2 border border-border-default rounded-fluent focus:ring-2 focus:ring-fpg-navy outline-none" defaultValue="Oceanic Harvest Pte Ltd" data-id="element-1387" />
              </div>
              <div className="space-y-1" data-id="element-1388">
                <label className="text-sm font-medium text-text-primary" data-id="element-1389">
                  Country of Incorporation *
                </label>
                <select className="w-full p-2 border border-border-default rounded-fluent focus:ring-2 focus:ring-fpg-navy outline-none" data-id="element-1390">
                  <option data-id="element-1391">Singapore</option>
                  <option data-id="element-1392">Malaysia</option>
                  <option data-id="element-1393">Indonesia</option>
                </select>
              </div>
              <div className="space-y-1" data-id="element-1394">
                <label className="text-sm font-medium text-text-primary" data-id="element-1395">
                  Date of Incorporation *
                </label>
                <input type="date" className="w-full p-2 border border-border-default rounded-fluent focus:ring-2 focus:ring-fpg-navy outline-none" defaultValue="2015-06-15" data-id="element-1396" />
              </div>
              <div className="space-y-1 md:col-span-2" data-id="element-1397">
                <label className="text-sm font-medium text-text-primary" data-id="element-1398">
                  Registered Address *
                </label>
                <input type="text" className="w-full p-2 border border-border-default rounded-fluent focus:ring-2 focus:ring-fpg-navy outline-none" defaultValue="123 Fishery Port Road, #02-15" data-id="element-1399" />
              </div>
            </div>
          </div>}

        {currentStepId === 'tax' && <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-1400">
            <h2 className="text-xl font-bold text-text-primary border-b border-border-light pb-4" data-id="element-1401">
              Tax & Registration
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1402">
              <div className="space-y-1" data-id="element-1403">
                <label className="text-sm font-medium text-text-primary" data-id="element-1404">
                  Business Registration Number (UEN) *
                </label>
                <input type="text" className="w-full p-2 border border-border-default rounded-fluent focus:ring-2 focus:ring-fpg-navy outline-none" defaultValue="201912345A" data-id="element-1405" />
              </div>
              <div className="space-y-1" data-id="element-1406">
                <label className="text-sm font-medium text-text-primary" data-id="element-1407">
                  GST Registration Number
                </label>
                <input type="text" className="w-full p-2 border border-border-default rounded-fluent focus:ring-2 focus:ring-fpg-navy outline-none" defaultValue="M90367890B" data-id="element-1408" />
              </div>
              <div className="space-y-1 md:col-span-2" data-id="element-1409">
                <label className="text-sm font-medium text-text-primary" data-id="element-1410">
                  Upload Business Registration Certificate *
                </label>
                <div className="border-2 border-dashed border-border-strong rounded-fluent p-8 text-center bg-surface-secondary" data-id="element-1411">
                  <p className="text-text-secondary mb-2" data-id="element-1412">
                    Drag and drop your file here, or click to browse
                  </p>
                  <Button variant="secondary" size="sm" data-id="element-1413">
                    Select File
                  </Button>
                </div>
              </div>
            </div>
          </div>}

        {currentStepId === 'bank' && <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-1414">
            <h2 className="text-xl font-bold text-text-primary border-b border-border-light pb-4" data-id="element-1415">
              Bank Details
            </h2>
            <MessageBar type="warning" data-id="element-1416">
              Bank details will be subject to a maker-checker verification
              process to prevent fraud.
            </MessageBar>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1417">
              <div className="space-y-1" data-id="element-1418">
                <label className="text-sm font-medium text-text-primary" data-id="element-1419">
                  Bank Name *
                </label>
                <input type="text" className="w-full p-2 border border-border-default rounded-fluent focus:ring-2 focus:ring-fpg-navy outline-none" defaultValue="DBS Bank Ltd" data-id="element-1420" />
              </div>
              <div className="space-y-1" data-id="element-1421">
                <label className="text-sm font-medium text-text-primary" data-id="element-1422">
                  Bank Code / SWIFT *
                </label>
                <input type="text" className="w-full p-2 border border-border-default rounded-fluent focus:ring-2 focus:ring-fpg-navy outline-none" defaultValue="DBSSGSG" data-id="element-1423" />
              </div>
              <div className="space-y-1" data-id="element-1424">
                <label className="text-sm font-medium text-text-primary" data-id="element-1425">
                  Account Number *
                </label>
                <input type="password" className="w-full p-2 border border-border-default rounded-fluent focus:ring-2 focus:ring-fpg-navy outline-none" defaultValue="123456789" data-id="element-1426" />
              </div>
              <div className="space-y-1" data-id="element-1427">
                <label className="text-sm font-medium text-text-primary" data-id="element-1428">
                  Confirm Account Number *
                </label>
                <input type="password" className="w-full p-2 border border-border-default rounded-fluent focus:ring-2 focus:ring-fpg-navy outline-none" defaultValue="123456789" data-id="element-1429" />
              </div>
              <div className="space-y-1 md:col-span-2" data-id="element-1430">
                <label className="text-sm font-medium text-text-primary" data-id="element-1431">
                  Upload Bank Letter / Void Cheque *
                </label>
                <div className="border-2 border-dashed border-border-strong rounded-fluent p-8 text-center bg-surface-secondary" data-id="element-1432">
                  <Button variant="secondary" size="sm" data-id="element-1433">
                    Select File
                  </Button>
                </div>
              </div>
            </div>
          </div>}

        {currentStepId === 'compliance' && <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-1434">
            <h2 className="text-xl font-bold text-text-primary border-b border-border-light pb-4" data-id="element-1435">
              Compliance & ESG
            </h2>
            <div className="space-y-4" data-id="element-1436">
              <div className="p-4 border border-border-light rounded-fluent bg-surface-secondary flex items-start gap-3" data-id="element-1437">
                <input type="checkbox" className="mt-1 w-4 h-4 text-fpg-navy" defaultChecked data-id="element-1438" />
                <div data-id="element-1439">
                  <h4 className="font-medium text-text-primary" data-id="element-1440">
                    Supplier Code of Conduct
                  </h4>
                  <p className="text-sm text-text-secondary" data-id="element-1441">
                    I acknowledge and agree to abide by the FairPrice Group
                    Supplier Code of Conduct.
                  </p>
                </div>
              </div>
              <div className="p-4 border border-border-light rounded-fluent bg-surface-secondary flex items-start gap-3" data-id="element-1442">
                <input type="checkbox" className="mt-1 w-4 h-4 text-fpg-navy" defaultChecked data-id="element-1443" />
                <div data-id="element-1444">
                  <h4 className="font-medium text-text-primary" data-id="element-1445">
                    Anti-Bribery and Corruption Declaration
                  </h4>
                  <p className="text-sm text-text-secondary" data-id="element-1446">
                    I declare that our company complies with all applicable
                    anti-bribery laws.
                  </p>
                </div>
              </div>
              <div className="space-y-1 pt-4" data-id="element-1447">
                <label className="text-sm font-medium text-text-primary" data-id="element-1448">
                  Do you have an ESG or Sustainability Policy? *
                </label>
                <select className="w-full p-2 border border-border-default rounded-fluent focus:ring-2 focus:ring-fpg-navy outline-none" data-id="element-1449">
                  <option data-id="element-1450">Yes, attached below</option>
                  <option data-id="element-1451">No, but in progress</option>
                  <option data-id="element-1452">No</option>
                </select>
              </div>
            </div>
          </div>}

        {currentStepId === 'review' && <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-1453">
            <h2 className="text-xl font-bold text-text-primary border-b border-border-light pb-4" data-id="element-1454">
              Review & Submit
            </h2>
            <MessageBar type="success" title="Ready to submit" data-id="element-1455">
              All required fields have been completed. Please review your
              information before submitting.
            </MessageBar>

            <div className="space-y-4" data-id="element-1456">
              <div className="flex justify-between p-4 border border-border-light rounded-fluent" data-id="element-1457">
                <span className="font-medium" data-id="element-1458">Company Details</span>
                <span className="text-status-success flex items-center gap-1" data-id="element-1459">
                  <CheckCircleIcon className="w-4 h-4" data-id="element-1460" /> Complete
                </span>
              </div>
              <div className="flex justify-between p-4 border border-border-light rounded-fluent" data-id="element-1461">
                <span className="font-medium" data-id="element-1462">Tax & Registration</span>
                <span className="text-status-success flex items-center gap-1" data-id="element-1463">
                  <CheckCircleIcon className="w-4 h-4" data-id="element-1464" /> Complete
                </span>
              </div>
              <div className="flex justify-between p-4 border border-border-light rounded-fluent" data-id="element-1465">
                <span className="font-medium" data-id="element-1466">Bank Details</span>
                <span className="text-status-success flex items-center gap-1" data-id="element-1467">
                  <CheckCircleIcon className="w-4 h-4" data-id="element-1468" /> Complete
                </span>
              </div>
              <div className="flex justify-between p-4 border border-border-light rounded-fluent" data-id="element-1469">
                <span className="font-medium" data-id="element-1470">Compliance & ESG</span>
                <span className="text-status-success flex items-center gap-1" data-id="element-1471">
                  <CheckCircleIcon className="w-4 h-4" data-id="element-1472" /> Complete
                </span>
              </div>
            </div>
          </div>}

        <div className="mt-8 pt-6 border-t border-border-light flex justify-between" data-id="element-1473">
          <Button variant="ghost" leftIcon={<ArrowLeftIcon className="w-4 h-4" data-id="element-1475" />} onClick={handleBack} disabled={currentStepId === 'company'} data-id="element-1474">
            Back
          </Button>
          <Button variant="primary" rightIcon={currentStepId !== 'review' ? <ArrowRightIcon className="w-4 h-4" data-id="element-1477" /> : undefined} onClick={handleNext} data-id="element-1476">
            {currentStepId === 'review' ? 'Submit Application' : 'Continue'}
          </Button>
        </div>
      </Card>
    </div>;
};